import Message from './message.vue'

const MESSAGE = {
  duartion: 3000, //显示时间 ms
  animateTime: 300,
  install(Vue) {
    Vue.component('Message', Message)

    function msg(text, callBack) {
      let msg = ''
      let duartion = MESSAGE.duartion
      if(typeof text === 'string') {
        msg = text
      }
      else if(text instanceof Object) {
        msg = text.text || ''
        if(text.duartion) {
          duartion = text.duartion
        }
      }
      let VueMessage = Vue.extend({
        render(h) {
          let props = {
            text: msg,
            show: this.show
          }
          return h('message', {props})
        },
        data() {
          return {
            show: false
          }
        }
      })

      let newMessage = new VueMessage()
      let vm = newMessage.$mount()
      let el = vm.$el
      document.body.appendChild(el)
      vm.show = true
      let timer1 = setTimeout(() => {
        clearTimeout(timer1)
        vm.show = false
        let timer2 = setTimeout(() => {
          clearTimeout(timer2)
          document.body.removeChild(el)
          newMessage.$destroy()
          vm = null
          callBack && (typeof callBack === 'function') && callBack()
        }, MESSAGE.animateTime)
      }, duartion)
    }

    Vue.prototype.$message = (text, callBack) => {
      if(!text) return
      msg(text, callBack)
    }
  }
}

export default MESSAGE


// WEBPACK FOOTER //
// ./src/components/message/index.js